import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import PodcastCreate from 'pages/creator/podcasts/podcast_create';
import { PodcastStore } from '@seedlang/stores';
import Paginator from 'components/paginator';
import autobind from 'autobind-decorator';
import { Link } from 'react-router';
import InPlaceText from 'components/form/in_place_text';
import PageTitle from 'components/common/page_title';

const Wrapper = styled.div`
  table {
    margin-top: 20px;
  }
`;

@observer
class PodcastIndex extends React.Component {

  constructor(props) {
    super(props);
    this.getPodcasts();
  }

  @autobind onDelete(id) {
    PodcastStore.destroy({ids: {podcastId: id}}, this.getPodcasts);
  }

  @autobind getPodcasts() {
    PodcastStore.getIndex();
  }

  render() {
    return (
      <Wrapper>
        <PageTitle>Podcasts</PageTitle>
        <PodcastCreate
          afterCreate={this.getPodcasts}
        />
        <table className='table-wrapper admin-table'>
          <thead>
            <tr>
              <th width='20' />
              <th width='80'>Pos</th>
              <th width='300'>Title</th>
            </tr>
          </thead>
          <tbody>
            {
              PodcastStore.indexData.map(item => {
                return (
                  <tr key={item.id}>
                    <td>
                      <Link
                        onlyActiveOnIndex
                        to={{ name: 'creator.podcasts.edit', params: { podcastId: item.id } }}
                        className='on-click'
                      >
                        <i className='fa fa-chevron-right fa-block' />
                      </Link>
                    </td>
                    <td>
                      <InPlaceText
                        id={item.id}
                        defaultValue={item.position}
                        model='podcasts'
                        field='position'
                        type='number'
                        step='1'
                        afterChange={this.getPodcasts}
                      />
                    </td>
                    <td style={{minWidth: '200px'}}>
                      <div className='text'>
                        <InPlaceText
                          field='title'
                          defaultValue={item.title}
                          model='podcasts'
                          id={item.id}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        <Paginator
          store={PodcastStore}
        />
      </Wrapper>
    );
  }
}

export default ErrorBoundary(PodcastIndex);
